module.exports = __webpack_public_path__ + "img/communication_path.3ddf25d9.png";